"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = require("crypto");
/**
 * Recursively sort the settings object alphabetically
 * @param settings - AxeDeveloperHub settings object
 * @returns
 */
const sortSettings = (settings) => {
    const sortedSettings = {};
    const keys = Object.keys(settings).sort();
    for (const key of keys) {
        const value = settings[key];
        if (typeof value === 'object') {
            //@ts-expect-error - TS doesn't like recursive types or object notation here
            sortedSettings[key] = sortSettings(value);
        }
        else {
            sortedSettings[key] = value;
        }
    }
    return sortedSettings;
};
/**
 * Utility function to hash the AxeDeveloperHub settings object
 * @see https://github.com/dequelabs/axe-api-team/blob/main/proposals/jazzband/wiring-up-a11y-threshold.md
 * @param settings - AxeDeveloperHub settings object
 * @returns - hash of settings object
 *
 */
const hashSettings = (settings) => {
    if (!settings) {
        return null;
    }
    /* This way we can maintain order when JSON.stringify()ing from/to Walnut */
    const sortedSettings = sortSettings(settings);
    return (0, crypto_1.createHash)('md5').update(JSON.stringify(sortedSettings)).digest('hex');
};
exports.default = hashSettings;
//# sourceMappingURL=hashSettings.js.map